import { API2_HOST } from '@/utils/constants';
import { BIND_APP_STATUS } from '@/utils/pageConfig/thirdApp';

import request from './request';
import { IBaseResponse } from './types/common';

export interface IBindAppParams {
  risk_token: string;
  telegram_callback: any;
}

const path = {
  bind: `/user/private/bind/telegram`,
  queryBindStatus: `/user/private/telegram-bind-status`,
  unbind: `/user/private/unbind/telegram`,
};

export function bindApp(params: IBindAppParams) {
  const url = `${API2_HOST}${path.bind}`;
  return request.post(url, { useCache: true, body: JSON.stringify(params) });
}

export function queryBindAppStatus() {
  const url = `${API2_HOST}${path.queryBindStatus}`;
  return request.get<
    IBaseResponse<{
      bind_status: BIND_APP_STATUS;
      username: string;
      last_name: string;
      first_name: string;
    }>
  >(url, {
    useCache: true,
  });
}

export function unbindApp(params: { risk_token: string }) {
  const url = `${API2_HOST}${path.unbind}`;
  return request.post(url, { useCache: true, body: JSON.stringify(params) });
}
